<template>
    <div class="contents">
        <div class="customer_wrap">
            <div class="cs_card">
                <div class="box">
                    <img src="../../assets/images/common/ico_cs.png" alt="고객센터 이용안내">
                    <p>고객센터 이용안내</p>
                    <h5>070.4233.0655</h5>
                    <span>FAX : 02)478-5822</span>
                </div>
                <p>운영시간</p>
                <span>월-금 09:00~17:30</span>
            </div>
            <div class="cs_tab">
                <ApiGuideNavigation/>
                <div class="cs_tabPanel active" id="cs_tab01">
                    <h5 class="title">부고 캠페인</h5>
                    <div class="search_wrap">
                        <div class="select_box">
                            <button type="button" class="btn_select" :class="showSelect ? 'on' : ''" @click="toggleSelect">{{ currentOption.name }}</button>
                            <ul class="select_list">
                                <li v-for="option in searchOptions"><button @click="selectOption(option)">{{ option.name }}</button></li>
                            </ul>
                        </div>
                        <span class="search_box">
                            <input type="text" placeholder="검색어를 입력 해주세요." v-model="searchInput">
                            <button type="button" @click="getSearch">검색버튼</button>
                        </span>
                    </div>
                    <div class="tbl_wrap">
                        <table class="basic">
                            <colgroup>
                                <col style="width: 20%;">
                                <col style="width: 10%;">
                                <col style="width: 18%;">
                                <col style="width: 12%;">
                                <col style="width: 20%;">
                                <col style="width: 20%;">
                            </colgroup>
                            <thead>
                                <tr>
                                    <th>캠패인 명</th>
                                    <th>제휴기관</th>
                                    <th>카테고리</th>
                                    <th>캠페인 코드</th>
                                    <th>운영비</th>
                                    <th>후원유형</th>
                                </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="row in funerals"
                                :key="`${row.campaignSeq}`"
                              >
                                <td>{{ row.campaignName }}</td>
                                <td>{{ row.partnerName }}</td>
                                <td>{{ row.categoryCampaignName }}</td>
                                <td>{{ row.campaignSeq }}</td>
                                <td>{{ $addComma(row.campaignAmount) }}</td>
                                <td>{{ row.type }}</td>
                                
                              </tr>
                            </tbody>
                        </table>
                    </div>
                    <CustomerServicePagination
                        :totalPages="totalPages()"
                        :currentPage="currentPage"
                        @changePage="changePage"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import CustomerServicePagination from '../common/CustomerServicePagination.vue';
import ApiGuideNavigation from '@/views/apiGuide/layout/ApiGuideNavigation.vue';


const apiGuideModule = 'apiGuideModule'

export default {
  components: {
    CustomerServicePagination,
    ApiGuideNavigation
  },

  data () {
    return {
      showSelect: false,
      searchOptions: [
        { name: '전체', value: 'all' },
        { name: '캠페인명', value: 'name' },
      ],
      searchType: 'all',
      searchWord: '',
      searchInput: '',
      currentSearch: '',
      currentPage: 1,
      currentOption: {
        name: '전체', value: 'all'
      }
    }
  },

  methods: {
    ...mapActions(apiGuideModule, ['requestCampaignApiList']),

    toggleSelect () {
      if (this.showSelect) {
        this.showSelect = false
      } else {
        this.showSelect = true
      }
    },

    selectOption(option) {
      this.currentOption = option
      this.showSelect = false
    },

    totalPages () {
      return Math.ceil(this.funeralCount / 10);
    },

    async changePage (page) {
      this.currentPage = page
      const {currentPage, searchType, searchWord} = this
      await this.requestCampaignApiList({currentPage, searchType, searchWord})
    },

    async getSearch(){ 
        this.searchWord = this.searchInput
        this.currentPage = 1
        const {currentPage, searchType, searchWord} = this
        await this.requestCampaignApiList({currentPage, searchType, searchWord})
    },

    toPage(pageName) {
      this.$router.push({ name: pageName })
    }
  },

  computed: {
    ...mapState(apiGuideModule, [
        'funerals',
        'funeralCount'
    ]),
  },

  watch: {
    currentOption(newVal) {
        this.searchType = newVal.value
    }
  },

  async mounted () {
    const {currentPage, searchType, searchWord} = this
    await this.requestCampaignApiList({currentPage, searchType, searchWord})
    //await this.requestPartnersWithDetails('funeral');
  }
}
</script>
<style scoped>
    table.basic tbody td {
        font-weight: 400;
        font-size: 14px;
        padding: 14px;
    }
</style>